export default "__VITE_ASSET__d6d85663__"